import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { ResearchSheet, UserInfo } from 'types';
import { Tooltip } from '@material-ui/core';
import { AuthCtx } from 'components/auth/auth-ctx';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    user: {
      display: 'flex',
      flexDirection: 'column',
      margin: '10px',
      lineHeight: '22px',
    },
    redText: {
      fontWeight: 'bold',
      color: theme.palette.primary.dark,
      textTransform: 'initial',
    },
    defaultText: {
      fontWeight: 600,
      fontSize: 14,
      color: 'black',
      textTransform: 'initial',
    },

    buttonText: {
      fontWeight: 'bold',
      color: 'white',
      textTransform: 'initial',
    },

    redirectToAdministrationButton: {
      padding: 5,
      minWidth: 0,
      '& svg': {
        fontSize: '1.8rem',
      },
    },
    avatar: {
      cursor: 'pointer',
    },
  })
);

interface AvatarInfoProps {
  userInfo?: UserInfo;
  userSheet?: ResearchSheet;
}

export const AvatarInfo = ({ userInfo, userSheet }: AvatarInfoProps) => {
  const { setUserInfo } = useContext(AuthCtx);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { firstName, lastName, currentlyUsedSheetOrdinalNumber } =
    userInfo ?? {};
  const { id: sheetId, ordinalNumber: sheetOrdinalNumber } = userSheet ?? {};

  const classes = useStyles();

  const redirectToAdmin = () => {
    localStorage.removeItem('userSheetId');
    window.location.href = `${window.location.origin}/badatelna/admin/research-sheet/${sheetId}`;
  };

  const handleOpenMenu = (e: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    setUserInfo?.(undefined);

    window.location.replace(`${window.location.origin}/logout`);
  };

  return (
    <div className={classes.root}>
      <div className={classes.root}>
        <Avatar onClick={handleOpenMenu} className={classes.avatar}>
          <PersonIcon />
        </Avatar>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={!!anchorEl}
          onClose={handleClose}
        >
          <MenuItem onClick={handleLogout}>Odhlásit se</MenuItem>
        </Menu>

        <Link to="/portfolio/badatelske-listy">
          <div className={classes.user}>
            <span
              className={classes.redText}
            >{`${firstName} ${lastName}`}</span>
            {sheetId === undefined && (
              <span className={classes.defaultText}>{`Badatelský list: ${
                currentlyUsedSheetOrdinalNumber ?? '-'
              }`}</span>
            )}

            {sheetId !== undefined && (
              <span className={classes.defaultText}>{`Objednávky pro BL: ${
                sheetOrdinalNumber ?? '-'
              }`}</span>
            )}
          </div>
        </Link>
      </div>

      {!!sheetId && (
        <Tooltip title="Přejít do Administrace">
          <Button
            component="span"
            color={'primary'}
            onClick={redirectToAdmin}
            className={classes.redirectToAdministrationButton}
          >
            <ExitToAppIcon />
          </Button>
        </Tooltip>
      )}
    </div>
  );
};
